import clsx from 'clsx';

/**
 * Pretty-print a JSON string (or value) in a compact, copyable code block.
 * Returns null if the input is null/undefined/empty.
 */
export function JsonView({
  value,
  className,
  maxHeight = '320px',
}: {
  value: string | null | undefined | object;
  className?: string;
  maxHeight?: string;
}) {
  if (value === null || value === undefined || value === '') return null;
  let pretty: string;
  if (typeof value === 'string') {
    try {
      pretty = JSON.stringify(JSON.parse(value), null, 2);
    } catch {
      pretty = value;
    }
  } else {
    pretty = JSON.stringify(value, null, 2);
  }
  return (
    <pre
      className={clsx(
        'overflow-auto rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 font-mono text-[11px] leading-relaxed text-slate-700',
        className,
      )}
      style={{ maxHeight }}
    >
      {pretty}
    </pre>
  );
}
